import { CancellablePromise, get, patch, post } from "@/api";
import type { SearchViewType, User } from "@/types";

export function setCompactArticlesExpanded(isExpanded: boolean) {
  return patch("/v1/me/settings", { compactArticlesExpanded: isExpanded });
}

export function setLanguage(language: string) {
  return patch("/v1/me/settings", { language });
}

export function setPreferredSearchView(preferredSearchView: SearchViewType) {
  return patch("/v1/me/settings", { preferredSearchView });
}

export function sendActivationMail(): CancellablePromise<{ email: string }> {
  return post("/v1/me/mail/activate");
}

export function getUser(): CancellablePromise<User> {
  return get("/v1/me");
}
